import { IComponentOptions } from "angular";
import { MachineConfigurationViewComponentController } from "./controller";

export const vsName = "machineConfigurationView";

export const MachineConfigurationViewComponentOptions: IComponentOptions = {
  controller: MachineConfigurationViewComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    machine: "<",
    machineConfiguration: "<",
    progressiveDefinition: "<",
    reportGroup: "<",
  },
};
